import React from "react";
import { spring, useCurrentFrame, useVideoConfig } from "remotion";

export interface FadeUpProps {
  delay?: number;
  yOffset?: number;
  damping?: number;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

/**
 * FadeUp component from Remotion Pro pattern
 * Uses smooth damping: 200 spring with subtle blur and translateY.
 */
export const FadeUp: React.FC<FadeUpProps> = ({
  delay = 0,
  yOffset = 30,
  damping = 200,
  children,
  style,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const p = spring({
    frame,
    fps,
    delay,
    config: { damping },
  });

  return (
    <div
      style={{
        opacity: p,
        transform: `translateY(${(1 - p) * yOffset}px)`,
        filter: `blur(${(1 - p) * 6}px)`,
        ...style,
      }}
    >
      {children}
    </div>
  );
};
